import React, { useEffect, useState } from "react";
import TableHeading from "../../components/common/TableHeading";
import {
  CLOSE_EYEICON,
  OPEN_EYEICON,
  RIGHTARROW_ICON,
} from "../../../utills/image-constant";
import Inputwithlable from "../../components/common/inputwithlable";
import DropDownWithLabel from "../../components/common/DropDownWithlable";
import { addAllAdmin, getallAdminRole } from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import { handleFormInput } from "../../../utills/formutilities";
import Loginbtn from "../../components/common/loginbtn";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/url-constant";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  checkValidation,
  ErrorMessage,
  ErrorMsg,
} from "../../../utills/error-message-constant";
import {
  emailRegex,
  NameRegex,
  NumberRegex,
  passwordRegex,
} from "../../../utills/form-regex";

const AddEmployee = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let EmployeeData = location?.state?.Data;
  let Employeetype = location?.state?.pageType;
  const [roleOptions, setRoleOptions] = useState([{
    value: "",
    label: "",
    Status: "",
  },
  ]);
  const [formError, setFormError] = useState();
  const [Employeebtndisable, setEmployeebtndisable] = useState(false);
  const [EmployeebtnLoader, setEmployeebtnLoader] = useState(false);
  const [allRoleList, setAllRoleList] = useState([]);
  const [employeeData, setEmployeeData] = useState({
    id: EmployeeData?.id ? EmployeeData?.id : "",
    name: EmployeeData?.name ? EmployeeData?.name : "",
    email: EmployeeData?.email ? EmployeeData?.email : "",
    password: EmployeeData?.password ? EmployeeData?.password : "",
    imageUrl: "",
    mobileNumber: EmployeeData?.mobileNumber ? EmployeeData?.mobileNumber : "",
    country: "",
    city: "",
    address: "",
    pinCode: "",
    roleId: EmployeeData?.roleResponsePayload?.id
      ? EmployeeData?.roleResponsePayload?.id
      : "",
  });
  const [passwordVisible, setPasswordVisible] = useState(false);

  const getallRole = async () => {
    const payload = {
      status: 1,
    };
    try {
      const response = await getallAdminRole(payload);
      if (response?.data?.responseCode === 200) {
        setAllRoleList(response?.data?.responseBody?.roleList);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  useEffect(() => {
    getallRole();
  }, []);

  useEffect(() => {
    const formattedRoleOptions =
      allRoleList &&
      allRoleList?.map((role) => ({
        value: role.id,
        label: role.roleName,
        Status: role.status,
      }));
    setRoleOptions(formattedRoleOptions);
  }, [allRoleList]);

  const handleAddEmployee = async () => {
    setEmployeebtndisable(true)
    setEmployeebtnLoader(true)
    if (Employeetype === "Edit") {
      if (
        !employeeData?.name ||
        !employeeData?.email ||
        !employeeData?.roleId

      ) {
        toastEmitter("error", "All Fields Required");
        setEmployeebtnLoader(false)
        setEmployeebtndisable(false)
        return;
      }
      if (!employeeData?.password) {
        toastEmitter("error", "Password Field Required");
        setEmployeebtnLoader(false)
        setEmployeebtndisable(false)
        return;
      }
    } else {
      // Check all fields for "Add" mode, including password
      if (
        !employeeData?.name ||
        !employeeData?.email ||
        !employeeData?.password ||
        !employeeData?.roleId
        // !employeeData?.mobileNumber
      ) {
        toastEmitter("error", "All Fields Required");
        setEmployeebtnLoader(false)
        return; // Stop execution if any field is empty
      }
    }
    if (
      formError?.nameStatus ||
      formError?.emailStatus ||
      formError?.passwordStatus
    ) {
      toastEmitter("error", "Please fill Vaild Data");
      return; // Stop execution if any field is empty
    }
    try {
      const response = await addAllAdmin(employeeData);
      if (response?.data?.responseCode !== 200) {
        toastEmitter("error", response?.data?.message);
        setEmployeebtndisable(false)
        setEmployeebtnLoader(false)
      }
      if (response.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
        navigate(ROUTES.EMPLOYEEMANAGEMENT);
        setEmployeebtndisable(false)
        setEmployeebtnLoader(false)
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
      setEmployeebtndisable(false)
      setEmployeebtnLoader(false)
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Name,
        NameRegex,
        formError,
        setFormError
      );
    }
    if (name === "email") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Email,
        emailRegex,
        formError,
        setFormError
      );
    }
    if (name === "password") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Password,
        passwordRegex,
        formError,
        setFormError
      );
    }
    if (name === "mobileNumber") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.MobileNumber,
        NumberRegex,
        formError,
        setFormError
      );
    }
    setEmployeeData(handleFormInput(e, employeeData));
  };

  const handleRoleChange = (e) => {
    setEmployeeData((prevData) => ({
      ...prevData,
      roleId: e.target.value, // Set the selected roleId
    }));
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const [isNumber, setIsNumber] = useState("us");

  const handleNumber = (e) => {
    setIsNumber(e);
    setEmployeeData({ ...employeeData, mobileNumber: e });
  };

  const handleNavigateBack = () => {
    navigate(ROUTES.EMPLOYEEMANAGEMENT);
  };

  return (
    <>
      <TableHeading
        className="cursor-pointer"
        firstData="Team Management"
        secondData="Team Employees"
        icon={RIGHTARROW_ICON}
        iconshow={true}
        thirdData={Employeetype == "Edit" ? "Update Employee" : Employeetype === "view" ? "View Employee" : "Add Employee"}
        onFirstDataClick={handleNavigateBack}
      />
      <div className="container-fluid ">
        <div className="caspera_employee_add">
          <div className="row">
            <div className="col-md-6">
              <Inputwithlable
                placeHolder="Enter Employee Name"
                name="name" // Unique name for the input
                type="text"
                labelName="Enter Employee Name"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                error={formError?.name}
                showastrict={true}
                value={employeeData.name} // Bind state value
                disable={Employeetype === "view"}
              />
              <ErrorMsg error={formError?.name} />
            </div>

            <div className="col-md-6 phoneinputdiv">
              <label htmlFor="inputState" className="form-label input-lable">
                Enter Mobile Number
              </label>

              <PhoneInput
                country={isNumber}
                enableAreaCodes={true}
                value={employeeData.mobileNumber}
                onChange={handleNumber}
                className="addInputText-lable"
                disable={Employeetype === "view"}
              />
            </div>

            <div className="col-md-6">
              <Inputwithlable

                placeHolder="Enter Email"
                name="email"
                type="text"
                showastrict={true}
                labelName="Enter Email"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                value={employeeData?.email}
                disable={Employeetype === "view"}
              />
              <ErrorMsg error={formError?.email} />
            </div>
            <div className="col-md-6">
              <DropDownWithLabel
                labelName="Select Role"
                lableclassName="addInput-label"
                name="modelId"
                options={roleOptions}
                showastrict={true}
                className="form-control addInputText-lable"
                value={employeeData?.roleId} // Bind selected value
                handleSelect={handleRoleChange} // Unified onChange handler for dropdown
                disabled={Employeetype === "view"}
              />
            </div>

            <>
              <div className="col-md-12  position-relative">
                <Inputwithlable
                  placeHolder="Employee Password"
                  name="password"
                  type={passwordVisible ? "text" : "password"}
                  labelName="Employee Password"
                  lableclassName="addInput-label"
                  className="form-control addInputText-lable"
                  handleChange={handleChange}
                  value={employeeData.password}
                  showastrict={true}
                  disable={Employeetype === "view"}
                />

                <img
                  src={passwordVisible ? OPEN_EYEICON : CLOSE_EYEICON}
                  alt="eye-icon"
                  className="password-eye-icon me-3 mt-2"
                  onClick={togglePasswordVisibility}
                />
              </div>
              <ErrorMsg error={formError?.password} />
            </>

          </div>
          <div className="pt-4 d-flex justify-content-center">
            {Employeetype === "view" ? "" :
              <Loginbtn
                className="submitbtn px-5"
                handleClick={handleAddEmployee}
                type="submit"
                btnName={Employeetype == "Edit" ? "Update" : "ADD"}
                disablebtn={Employeebtndisable}
                loader={EmployeebtnLoader}
              />
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default AddEmployee;
